<template>
  <UTooltip
    v-if="shouldDisplayEnterpriseTag"
    :text="upgradeModalTitle??'You need a Enterprise plan to use this feature'"
    class="inline normal-case"
  >
    <div
      v-track.enterprise_tag_click="{title:upgradeModalTitle}"
      class="bg-green-200 text-green-700 border border-green-700 px-2 text-xs uppercase inline rounded-full font-semibold cursor-pointer"
      @click.stop="onClick"
    >
      Enterprise
    </div>
  </UTooltip>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  upgradeModalTitle: {
    type: String
  },
  upgradeModalDescription: {
    type: String
  }
})

const subscriptionModalStore = useSubscriptionModalStore()
const authStore = useAuthStore()
const workspacesStore = useWorkspacesStore()
const user = computed(() => authStore.user)
const workspace = computed(() => workspacesStore.getCurrent)

const shouldDisplayEnterpriseTag = computed(() => {
  return false
  if (!user.value || !workspace.value)
    return true
  return !workspace.value?.is_enterprise
})

function onClick () {
  subscriptionModalStore.setModalContent(props.upgradeModalTitle, props.upgradeModalDescription)
  subscriptionModalStore.openModal()
}
</script>
